<template>
	<div class="dialogDetailPlan">
		<dialogTitle name="方案信息" />
		<div class="dialogDetailPlanMsg">
			<p>
				<span>方案编号：</span
				><span>{{ detailComp.bh ? detailComp.bh : '-' }}</span>
			</p>
			<p>
				<span>业务类型：</span
				><span>{{ detailComp.type ? detailComp.type : '-' }}</span>
			</p>
			<p>
				<span>企业名称：</span
				><span>{{
					detailComp.comname ? detailComp.comname : '-'
				}}</span>
			</p>
			<p>
				<span>申请区域：</span
				><span>{{ detailComp.region ? detailComp.region : '-' }}</span>
			</p>
			<p>
				<span>公司地址：</span
				><span>{{
					detailComp.comaddress ? detailComp.comaddress : '-'
				}}</span>
			</p>
		</div>
		<dialogTitle name="关闭原因" />
		<div class="dialogDetailPlanMsg">
			<p>暂无</p>
		</div>
	</div>
</template>
<script>
import dialogTitle from './dialogtitle'
import { submitIcpProgramme } from '@/api/alicp.js'
export default {
	props: ['detailComp'],
	components: {
		dialogTitle,
	},
}
</script>

<style lang="scss">
.dialogDetailPlan {
	width: 100%;
	padding-left: 30px;
	.dialogDetailPlanMsg {
		width: 100%;
		padding-left: 50px;
		p {
			width: 100%;
			margin-bottom: 15px;
			span {
				margin-right: 10px;
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(0, 0, 0, 0.63);
				line-height: 22px;
			}
		}
	}
}
</style>
